import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TabsModule } from "primeng/tabs";
import { ProductDetailInfos } from "../product-detail-infos/product-detail-infos";
import { CommonModule } from '@angular/common';
import { ProductDetailStocks } from "../product-detail-stocks/product-detail-stocks";
import { ProductDetailExpeditions } from "../product-detail-expeditions/product-detail-expeditions";
import { PhotoService } from '@app/pages/service/photo.service';
import { GalleriaModule } from 'primeng/galleria';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Photo, Product } from '@app/core/interfaces';
import { ProductDetailPhotos } from '../product-detail-photos/product-detail-photos';
import { ProductService } from '@app/core/services';
import { takeUntil } from 'rxjs';
import { BaseComponent } from '@app/core/bases';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProductDetailDistribution } from "../product-detail-distribution/product-detail-distribution";
import Viewer from 'viewerjs';
import html2pdf from 'html2pdf.js';
import {ProductDetailHistoriques} from "@app/features/product/product-detail-historiques/product-detail-historiques";
import {MessageModule} from "primeng/message";
import {Tooltip} from "primeng/tooltip";

export interface TabStates {
  index: number
  active: boolean
  loaded: boolean
}

@Component({
  selector: 'app-product-detail',
    imports: [CommonModule, TabsModule, GalleriaModule, ProductDetailInfos, ProductDetailStocks, ProductDetailExpeditions, ProductDetailPhotos, TagModule, ButtonModule, ToggleSwitchModule, FormsModule, BreadcrumbModule, ProgressSpinnerModule, ProductDetailDistribution, ProductDetailHistoriques, MessageModule, Tooltip],
  providers: [PhotoService],
  templateUrl: './product-detail.html'
})
export class ProductDetail extends BaseComponent implements OnInit {
  @Input() product!: Product;

  @ViewChild('etiquette') etiquetteElement!: any;

  images: any = [];

  responsiveOptions: any[] = [
      {
          breakpoint: '1300px',
          numVisible: 4
      },
      {
          breakpoint: '575px',
          numVisible: 1
      }
  ];

  checked: boolean = true;

  items: MenuItem[] = [{ label: 'Produits', routerLink: '/products' }];

  home: MenuItem = { icon: 'pi pi-home', routerLink: '/' };

  activeTab: number = 0;
  tabStates: TabStates[] = []

  viewerActiveIndex: number = 0;
  viewerInstance!: Viewer;

  isLoadingPhoto: boolean = false
  isValidatingProduct: boolean = false

  constructor(private productService: ProductService) {
    super();
  }

  ngOnInit() {
    this.items.push({ label: this.product.marque?.nom + ' ' + this.product.reference })
    this.getProductPhotos();
    this.tabStates = [
      {index: 0, active: this.activeTab === 0, loaded: false},
      {index: 1, active: this.activeTab === 1, loaded: false},
      {index: 3, active: this.activeTab === 3, loaded: false},
      {index: 4, active: this.activeTab === 4, loaded: false},
      {index: 5, active: this.activeTab === 5, loaded: false},
      {index: 6, active: this.activeTab === 6, loaded: false},
      {index: 7, active: this.activeTab === 7, loaded: false},
    ]

    const fusion = this.route.snapshot.queryParamMap.get('fusion')
    if (fusion) {
      if (fusion === 'true')
        this.toastService.add({ severity: 'info', summary: 'Fusion', detail: `Cette référence a été détectée dans votre stock.\nVous avez été rédirigée vers celle-ci.` })
      else
        this.toastService.add({ severity: 'success', summary: 'Création', detail: `Le produit a été créé avec succès` })

      this.location.replaceState(this.location.path().split('?')[0]); // remove query param from url
    }

    const tab = parseInt(this.route.snapshot.queryParamMap.get('tab') || '0')
    if (tab && tab !== this.activeTab) {
      this.activeTab = tab
      this.onTabChange(tab)
    }
  }

  getProductPhotos(): void {
    this.isLoadingPhoto = true;

    this.productService
      .getPhotoCollection(this.product.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.product = { ...this.product, photos:  data.results };
        },
        complete: () => {
          this.isLoadingPhoto = false;
        }
      });
  }

  showViewer(event: Event) {
    if (this.viewerInstance) {
      this.viewerInstance.destroy();
    }

    const gallery = document.createElement('div');
    this.product['photos']?.forEach((photo: Photo, index: number, photos: Photo[]) => {
      const img = new Image();
      img.src = this.apiUrl + photo.url;
      gallery.appendChild(img)
    })

    this.viewerInstance = new Viewer(gallery, {
      transition: false,
      ...this.viewerOptions,
      initialViewIndex: this.viewerActiveIndex
    });
    this.viewerInstance.show()
  }

  onTabChange(newIndex: string | number | undefined) {
    this.tabStates.map((state) => state.active = state.index === newIndex);
    this.tabStates = [...this.tabStates]
    this.location.replaceState(this.location.path().split('?')[0], `tab=${newIndex}`);
  }

  onEtiquettePrint() {
    if (!this.etiquetteElement) return;

    const element = this.etiquetteElement.nativeElement;
    const options = {
      margin: 1,
      filename: `Etiquette_${this.product.id}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { dpi: 300, letterRendering: true, scale: 4, useCORS: true },
      jsPDF: { unit: 'mm', orientation: 'landscape', format: [100, 56] },
    };

    html2pdf().set(options).from(element).save();
  }

    onValidatingModification(product: Product) {
        this.isValidatingProduct = true

        this.productService.postValidateEbayModification(product.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    // console.log("synchronizeMarketplace response", response);
                    this.toastService.add({ severity: 'success', summary: 'Validation', detail: `Lecture des modifications validées.` })
                    this.isValidatingProduct = false
                    this.product.modification_ebay_a_verifier = false
                },
                error: (error) => {
                    // console.error("synchronizeMarketplace error", error);
                    this.toastService.add({ severity: 'error', summary: 'Error', detail: `Echec de la validation.` })
                    this.isValidatingProduct = false
                }
            });
    }
}
